import { HTTPError } from './errors';
import { type SuccessResponse } from './types';

type ResponseHeaders = {
  headers: Record<string, string>;
};

export type QueryResponse<T> = T & ResponseHeaders;

export const createQuery = (baseInit?: RequestInit) => <TResponse extends SuccessResponse>(
  url: string, init?: RequestInit
) => fetch(url, { ...baseInit, ...init }).then(async (res) => {
    const response = await res.json();

    if (!res.ok) throw new HTTPError(res.status, res.statusText, response);

    const headers = Object.fromEntries(res.headers.entries());

    const result: QueryResponse<TResponse> = { ...response, headers };

    return result;
  });

const query = createQuery({ credentials: 'include' });

const makeRequest = (
  method: RequestInit['method']
) => <TResponse extends SuccessResponse, TBody = Record<string, unknown>>(
  url: string,
  body: TBody
) => query<TResponse>(url, {
  method,
  body: body ? JSON.stringify(body) : undefined,
});

export const api = {
  get: query,
  post: makeRequest('POST'),
  delete: makeRequest('DELETE'),
  put: makeRequest('PUT'),
  patch: makeRequest('PATCH'),
};
